module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "the-people-in-my-book"
    }
  }, [_c('h1', [_vm._v("The People in My Book")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    staticStyle: {
      "width": "3.20833in",
      "height": "1.88819in"
    },
    attrs: {
      "alt": "C:\\Users\\Am\\Pictures\\PIC\\1.jpg",
      "src": "Images/file1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("C:\\Users\\Am\\Pictures\\PIC\\1.jpg")])]), _vm._v(" "), _c('p', [_vm._v("Our regular Friday Night dinners at Liz’ and Nic’s Pub in the villa grounds. Most of the English, and other, people we met through the Pub dinners.")]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "nic-and-liz-owners-of-riverside-cottages-and-pub"
    }
  }, [_c('h3', [_c('strong', [_vm._v("Nic and Liz")]), _vm._v(" – owners of “Riverside Cottages” and Pub")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "section"
    }
  }, [_c('h3')]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "john-maintenance-man-and-some-time-barman-at-villas"
    }
  }, [_c('h3', [_c('strong', [_vm._v("John")]), _vm._v(" – Maintenance Man and some-time barman at Villas")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "section-1"
    }
  }, [_c('h3')]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "lucy-the-gardener-at-the-villas-she-owns-rosie"
    }
  }, [_c('h3', [_c('strong', [_vm._v("Lucy")]), _vm._v(" – the gardener at the Villas – she owns Rosie")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "section-2"
    }
  }, [_c('h3'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Andrea and Mark and Amy")]), _vm._v(" – English couple who live in the Villas – Mark works part time in London")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "morat-the-scottish-upholsterer-and-some-time-cook-at-the-pub"
    }
  }, [_c('h3', [_c('strong', [_vm._v("Morat")]), _vm._v(" – the Scottish upholsterer and some-time cook at the Pub")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "section-3"
    }
  }, [_c('h3'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Mark")]), _vm._v(" – a Scottish art-dealer who sells art online from his home in the old main street")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Sue and John")]), _vm._v(" – bought a villa in Aubusson and fly over once a year for their annual holidays from Australia")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Tim and Linda")]), _vm._v(" – they have bought three villas in Aubusson")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Mr and Mrs ‘Caravan Dave’")]), _vm._v(" – an English couple who run a caravan in the UK and bought a villa here to renovate")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "alan-a-single-man-who-bought-a-villa-here-and-renovates-other-english-peoples-villas-for-them"
    }
  }, [_c('h3', [_c('strong', [_vm._v("Alan")]), _vm._v(" – a single man who bought a Villa here and renovates other English people’s Villas for them")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "section-4"
    }
  }, [_c('h3'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Christa and Milan")]), _vm._v(" – a couple staying at the Villas – they are Serbian and South African and have an Aussie daughter")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Mark and Richard")]), _vm._v(" – staying in next Villa to ours – Alan from Doc Martin country (Cornwall)")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("‘Henry VIII’ and Ann")]), _vm._v(" – Henry got that name as he has too many wives and children to remember all their names!")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Georgina")]), _vm._v(" – an English lady who is semi-retired to a tiny village outside of Aubusson – Mautes. She flies back to London to work on occasions")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Jacques")]), _vm._v(" – the devilish real estate agent in Aubusson – we call him ‘Black Adder’ because he dresses in all black")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Pauline and Ron –")]), _vm._v(" Georgina’s parents who work a sheep property in Mautes (in their 80’s)")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Our ‘first best friend’")]), _vm._v(" – she corners us in Aubusson lanes and wants to kiss us to look like she knows us Aussies well")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Our ’second best friend")]), _vm._v("’ – who does the same as our ‘first best friend’")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "rosie-the-gorgeous-dog-owned-by-lucy"
    }
  }, [_c('h3', [_c('strong', [_vm._v("Rosie")]), _vm._v(" – the gorgeous dog owned by Lucy")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1bb813e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch006.vue
// module id = 78
// module chunks = 0